<template>
  <div class="attachment-detail">
    <template v-if="hasUrl">
      <FilePreview :value="url" />
    </template>

    <template v-else>
      <div v-if="isOrderDetail" class="custom-detail order-detail">
        <template v-if="orderDetailLoading">
          <span class="placeholder">加载订单信息…</span>
        </template>
        <template v-else>
          <el-button type="text" size="small" @click="goPassengerUserDetail()">用户详情</el-button>
          <el-button type="text" size="small"><span v-goRouteDetail="bizId">订单详情</span></el-button>
          <el-button type="text" size="small" @click="showRoutePlan()">行程规划</el-button>
          <el-button type="text" size="small" @click="go2QcPage()"><span>质检详情</span></el-button>
        </template>
      </div>

      <div v-else-if="isRouteDetail" class="custom-detail route-detail">
        <el-button type="text" size="small" @click="showRoutePlan()">行程规划</el-button>
        <el-button type="text" size="small" @click="showRouteList()">行程详情</el-button>
        <el-button type="text" size="small" @click="go2QcPage()"><span>质检详情</span></el-button>
      </div>

      <div v-else-if="isNoticeDetail" class="custom-detail notice-detail">
        <el-button type="text" size="small" @click="openNoticeContent()">通知内容</el-button>
      </div>

      <div v-else-if="isPunishDetail" class="custom-detail punish-detail">
        <template v-if="punishDetailLoading">
          <span class="placeholder">加载罚单信息…</span>
        </template>
        <template v-else>
          <el-button type="text" size="small" @click="goPunishDetail()">罚单详情</el-button>
          <template v-if="punishRouteIdPresent">
            <el-button type="text" size="small" @click="showRoutePlan()">行程规划</el-button>
            <el-button type="text" size="small" @click="showRouteList()">行程详情</el-button>
            <el-button type="text" size="small" @click="go2QcPage()"><span>质检详情</span></el-button>
          </template>
        </template>
      </div>

    </template>

    <el-dialog
      :visible.sync="noticeDialogVisible"
      title="通知内容"
      width="560px"
      append-to-body
      :close-on-click-modal="false"
      @closed="onNoticeDialogClosed"
    >
      <div v-loading="noticeLoading" class="notice-detail-body">
        <template v-if="noticeRecord">
          <div class="notice-row">
            <span class="notice-label">标题</span>
            <div class="notice-value">{{ noticeRecord.title || "—" }}</div>
          </div>
          <div
            v-if="noticeRecord.subTitle && noticeRecord.subTitle !== noticeRecord.title"
            class="notice-row"
          >
            <span class="notice-label">副标题</span>
            <div class="notice-value">{{ noticeRecord.subTitle }}</div>
          </div>
          <div class="notice-row">
            <span class="notice-label">内容</span>
            <div class="notice-value notice-value--html" v-html="noticeRecord.content || '—'"></div>
          </div>
          <div v-if="noticeImageUrls.length" class="notice-row">
            <span class="notice-label">图片</span>
            <div class="notice-images">
              <el-image
                v-for="(url, idx) in noticeImageUrls"
                :key="idx"
                :src="url"
                fit="cover"
                class="notice-img"
                :preview-src-list="noticeImageUrls"
              />
            </div>
          </div>
        </template>
      </div>
      <span slot="footer">
        <el-button size="small" type="primary" @click="noticeDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FilePreview from "@/components/FilePreview";
import { SHOW_PUNISH_DIAG, SHOW_ROUTE_PLAN } from "@/core/const/global-event";
import Router from "@/route";
import { getOrderDetail } from "@/api/order";
import { getPunishBill } from "@/api/driver_punish";
import { getNoticeSendingRecordRecord } from "@/api/notice";

export default {
  name: "AttachmentDetail",
  components: { FilePreview },
  props: {
    attachmentType: {
      type: [Number, String],
      default: null
    },
    bizId: {
      type: [Number, String],
      default: null
    },
    url: {
      type: String,
      default: ""
    },



  },
  computed: {
    hasUrl() {
      return this.url && typeof this.url === "string" && this.url.trim().length > 0;
    },
    isOrderDetail() {
      return this.typeConfig.orderTypes.includes(this.attachmentType);
    },
    isRouteDetail() {
      return this.typeConfig.routeTypes.includes(this.attachmentType);
    },
    isPunishDetail() {
      return this.typeConfig.punishTypes.includes(this.attachmentType);
    },
    isNoticeDetail() {
      return this.typeConfig.noticeTypes.includes(this.attachmentType);
    },
    punishRouteIdPresent() {
      const rid = this.punishBill && this.punishBill.routeId;
      return rid != null && rid !== "";
    },
    /** 订单附件场景：bizId 为 orderId，行程相关操作需使用订单上的 routeId */
    resolvedRouteId() {
      if (this.isRouteDetail) {
        return this.bizId;
      }
      if (this.isOrderDetail && this.orderDetail) {
        return this.orderDetail.routeId;
      }
      if (this.isPunishDetail && this.punishBill) {
        return this.punishBill.routeId;
      }
      return null;
    },
    /** 后端订单详情字段为 telephone，与列表等处 passengerTel 含义一致 */
    passengerTel() {
      if (!this.isOrderDetail || !this.orderDetail) {
        return "";
      }
      return this.orderDetail.telephone || this.orderDetail.passengerTel || "";
    }
  },
  data() {
    return {
      typeConfig: {
        orderTypes: ["ORDER"],
        routeTypes: ["ROUTE"],
        punishTypes: ["PUNISH"],
        noticeTypes: ["NOTICE"]
      },
      orderDetail: null,
      orderDetailLoading: false,
      punishBill: null,
      punishDetailLoading: false,
      noticeDialogVisible: false,
      noticeLoading: false,
      noticeRecord: null,
      noticeImageUrls: []
    };
  },

  watch: {
    bizId: {
      handler() {
        this.syncOrderDetail();
        this.syncPunishDetail();
      },
      immediate: true
    },
    attachmentType() {
      this.syncOrderDetail();
      this.syncPunishDetail();
    }
  },

  methods: {
    syncOrderDetail() {
      if (!this.isOrderDetail || !this.bizId) {
        this.orderDetail = null;
        this.orderDetailLoading = false;
        return;
      }
      this.orderDetailLoading = true;
      getOrderDetail(this.bizId, { _hideLoading: true })
        .then((res) => {
          this.orderDetail = res.data || null;
        })
        .finally(() => {
          this.orderDetailLoading = false;
        });
    },

    syncPunishDetail() {
      if (!this.isPunishDetail || !this.bizId) {
        this.punishBill = null;
        this.punishDetailLoading = false;
        return;
      }
      this.punishDetailLoading = true;
      getPunishBill(this.bizId, { _hideLoading: true })
        .then((res) => {
          this.punishBill = res.data || null;
        })
        .finally(() => {
          this.punishDetailLoading = false;
        });
    },

    goPunishDetail() {
      const open = (bill) => {
        if (!bill) {
          this.$message.warning("未找到罚单");
          return;
        }
        this.$bus.$emit(SHOW_PUNISH_DIAG, { punishBill: bill, viewMode: true });
      };
      if (this.punishBill) {
        open(this.punishBill);
        return;
      }
      if (!this.bizId) {
        this.$message.warning("罚单 ID 无效");
        return;
      }
      getPunishBill(this.bizId, { _hideLoading: true }).then((res) => {
        this.punishBill = res.data || null;
        open(this.punishBill);
      });
    },

    openNoticeContent() {
      if (!this.isNoticeDetail) {
        return;
      }
      const id = parseInt(String(this.bizId).trim(), 10);
      if (!Number.isFinite(id)) {
        this.$message.warning("通知 ID 无效");
        return;
      }
      this.noticeDialogVisible = true;
      this.noticeLoading = true;
      this.noticeRecord = null;
      this.noticeImageUrls = [];
      getNoticeSendingRecordRecord(id, { _hideLoading: true })
        .then((res) => {
          this.noticeRecord = res.data || null;
          this.noticeImageUrls = this.extractNoticeImageUrls(this.noticeRecord);
        })
        .finally(() => {
          this.noticeLoading = false;
        });
    },
    extractNoticeImageUrls(record) {
      if (!record || !Array.isArray(record.fields)) {
        return [];
      }
      const urls = [];
      record.fields.forEach((f) => {
        if (f && f.type === "img" && f.value) {
          urls.push(f.value);
        }
      });
      return urls;
    },
    onNoticeDialogClosed() {
      this.noticeRecord = null;
      this.noticeImageUrls = [];
    },

    ensureRouteIdForOrderOps() {
      const rid = this.resolvedRouteId;
      if (rid == null || rid === "") {
        this.$message.warning("暂无关联行程，无法打开");
        return false;
      }
      return true;
    },

    goPassengerUserDetail() {
      const tel = (this.passengerTel || "").trim();
      if (!tel) {
        this.$message.warning("暂无乘客手机号，无法打开用户详情");
        return;
      }
      const { href } = Router.resolve({
        path: "/passenger/list",
        query: { tel }
      });
      window.open(href, "_blank");
    },

    showRoutePlan() {
      if (!this.ensureRouteIdForOrderOps()) {
        return;
      }
      this.$bus.$emit(SHOW_ROUTE_PLAN, { id: this.resolvedRouteId }, false);
      // this.$emit("close");
    },

    go2QcPage() {
      if (!this.ensureRouteIdForOrderOps()) {
        return;
      }
      const { href } = Router.resolve({
        path: "/route/qc",
        query: { routeId: this.resolvedRouteId }
      });
      window.open(href, "_blank");
    },

    showRouteList() {
      if (!this.ensureRouteIdForOrderOps()) {
        return;
      }
      const { href } = Router.resolve({
        path: "/route/list",
        query: { routeId: this.resolvedRouteId }
      });
      window.open(href, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.attachment-detail {
  width: 100%;
  min-height: 40px;

  .custom-detail {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
  }

  .placeholder {
    color: #c0c4cc;
    font-size: 13px;
  }
}

.notice-detail-body {
  min-height: 80px;
}

.notice-row {
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
}

.notice-label {
  display: block;
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.notice-value {
  font-size: 13px;
  color: #303133;
  word-break: break-word;

  &--html {
    line-height: 1.5;
  }
}

.notice-images {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.notice-img {
  width: 96px;
  height: 96px;
  border-radius: 4px;
}
</style>
